const { connect } = require("react-redux");
const DownloadDialog = require("components/Dialog/DownloadDialog");
const DialogActions = require("actions/dialog");

const internals = {};

internals.connect = connect(
    state => ({
        // key ensures that DownloadDialog rerenders dependent on downloadCroquisId set in state
        key: state.dialog.downloadCroquisId,
        croquis: state.dialog.downloadCroquisId && {
            ...state.croquis.purchased[state.dialog.downloadCroquisId],
            // Overwrite record's downloadPackage (id) with full download package object
            downloadPackage:
                state.checkout.downloadPackages.dict[
                    state.croquis.purchased[state.dialog.downloadCroquisId]
                        .downloadPackage
                ]
        },
        dialogOpen: state.dialog.isDownloadOpen,
        token: state.auth.credentials.token,
        renderingOptions: state.croquis.renderingOptions
    }),
    {
        dialogClose: DialogActions.closeDownloadDialog
    }
);

module.exports = internals.connect(DownloadDialog);



// WEBPACK FOOTER //
// ./src/containers/DownloadDialog.js